module.exports = __webpack_public_path__ + "components/ski-hire-promo/static/ski-hire--background-cb78eef8af223fb09d6dc68b1c194326.jpg";